export default "__VITE_ASSET__CeSPO2Xb__"